// See findNonRecoverableErrors() for similar functionality.

// Ignore messages that contain any of these strings in any position.
const ignoreStrings = [
    'the requested template could not be found for the current company',
    'user pressed cancel',
    'propoint agent is not connected',
    'a member cannot be unredeemed twice on the same day',
    'this membership has already been redeemed/unredeemed today',
    'cannot over-redeem an order line',
    'email address is already in use on another account',
    'unknown device',
    'not online',
    'the trading session has already ended',
    'non-error promise rejection captured',
];

// Ignore messages that match these regular expressions.
const ignoreRegexs = [
    /Reservation \\?"[A-Za-z0-9]+\\?" does not exist/i,
    /does not have the (.+) privilege/i,
    /API Error 404 .+\/v2\/orders\/[A-Za-z0-9]+ {"error":"The requested resource was not found"}/i,
    /^ignoring duplicate hash$/i,
];

const stringShouldBeIgnored = (str) => {
    str = str.toLowerCase();

    // eslint-disable-next-line unused-imports/no-unused-vars
    for (const ignoreStr of ignoreStrings) {
        if (str.includes(ignoreStr)) {
            return true;
        }
    }

    // eslint-disable-next-line unused-imports/no-unused-vars
    for (const ignoreRegex of ignoreRegexs) {
        if (str.match(ignoreRegex)) {
            return true;
        }
    }

    return false;
};

// An array of functions that can be used to process the Event.
// The functions are processed in order with the most likely events to be encountered first. If a function returns null
// then no further functions are processed. Alternatively the function can either return the event unchanged or modify
// the event and then return it where the event will then be passed to the next function in the array.
const eventProcessors = [
    (event) => {
        // Ignore messages that contain any of the ignoreStrings or ignoreRegexs in their 'message' property.
        if (event.message) {
            if (stringShouldBeIgnored(event.message)) {
                return null;
            }
        }

        return event;
    },
    (event) => {
        // Ignore exceptions that contain any of the ignoreStrings or ignoreRegexs in their 'exception' property.
        if (
            event.exception
            && event.exception.values
            && event.exception.values[0]
            && event.exception.values[0].value
        ) {
            if (stringShouldBeIgnored(event.exception.values[0].value)) {
                return null;
            }
        }

        return event;
    },
];

/**
 * This method is called by Sentry.beforeSend() which simply returns the value returned here. Returning null means that
 * the event is dropped and does not get sent to Sentry. The data you return is sent to Sentry which means that this is
 * one of the places we can modify an event, for example we could add additional data, re-shape, or sanitize data.
 *
 * @param {Event} event
 *
 * @return {null|Event}
 */
const sentryBeforeSendEventProcessor = (event) => {
    // eslint-disable-next-line unused-imports/no-unused-vars
    for (const processor of eventProcessors) {
        const result = processor(event);
        if (!result) {
            return null;
        }
        event = result;
    }
    return event;
};

module.exports = sentryBeforeSendEventProcessor;
